module.exports = __webpack_public_path__ + "img/Diseño-SItio-web_02.2036251d.jpg";